var map = {
	"./": 10701,
	"./en_US": 4229,
	"./en_US.js": 4229,
	"./index": 10701,
	"./index.js": 10701,
	"./ko_KR": 34107,
	"./ko_KR.js": 34107,
	"./kz_KZ": 44422,
	"./kz_KZ.js": 44422,
	"./mn_MN": 56834,
	"./mn_MN.js": 56834,
	"./ru_RU": 69234,
	"./ru_RU.js": 69234
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__(id);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 20679;
module.exports = webpackAsyncContext;